const questions = [
    {
      question: "Em que ano a Barbie foi lançada pela primeira vez?",
      options: ["1955", "1959", "1963"],
      answer: "1959",
    },
    {
       question:"Qual é o nome completo da Barbie?",
       options: ["Barbara Roberts","Barbara Millicent Roberts", "Barbie Johnson"],
       answer:"Barbara Millicent Roberts"
    },
    {
        question: "Qual profissão a Barbie ainda NÃO teve em suas muitas carreiras?",
        options: ["Astronauta", "Engenheira", "Cientista da computação"],
        answer: "Cientista da computação",
      },
      {
        question: "Quantas nacionalidades diferentes a Barbie já foi lançada?",
        options: ["Mais de 30 nacionalidades", "Mais de 50 nacionalidades", "Mais de 100 nacionalidades"],
        answer: "Mais de 50 nacionalidades",
      },
      {
        question: "Em que ano a Barbie se tornou a primeira boneca a viajar para o espaço?",
        options: ["1969", "1972", "1981"],
        answer: "1969",
      },
      {
        question: "Qual foi a primeira boneca negra lançada pela Mattel?",
        options: ["Crystal Barbie", "Christie Barbie", "Francie Barbie"],
        answer: "Christie Barbie",
      },
      {
        question: "Qual foi a edição especial da Barbie que homenageou sua aparência original de 1959 em seu 50º aniversário?",
        options: ["Vintage Barbie", "Barbie Heritage", "Barbie Glamour"],
        answer: "Barbie Glamour",
      },
      {
        question: "Em 2016, a Mattel lançou uma linha de bonecas que incluía diferentes tipos de corpo. Quais eram os nomes das três novas formas corporais da Barbie?",
        options: ["Petite, Tall e Curvy", "Slim, Regular e Plus", "Skinny, Athletic e Voluptuous"],
        answer: "Petite, Tall e Curvy",
      },
      {
        question: "Qual é o nome da casa icônica da Barbie?",
        options: ["Casa da Barbie", "Dreamhouse da Barbie", "Casa dos Sonhos da Barbie"],
        answer: "Dreamhouse da Barbie",
      },
      {
        question: "Em qual área a Barbie foi homenageada com o prêmio 'Living Legend' pela Biblioteca do Congresso dos Estados Unidos em 2010?",
        options: ["Ciência", "Música", "Brinquedos"],
        answer: "Brinquedos",
      },
  ];
  
  export default questions;